// Hardcoded CSM fallback — shown whenever a company has no assigned CSM
// (the /csm endpoint returns empty or errors, or an order has no assigned_user).
// Keeps every CSM card populated instead of hiding it. See the CSM audit.
export const PIOTR_CSM_FALLBACK = {
  id: 337,
  first_name: "Piotr",
  last_name: "Kochanski",
  email: "piotr.kochanski@teamsunday.com",
  phone_number: "+48 511 423 125",
  profile_picture: "https://storage.teamsunday.com/media/user/15702/Sn3CKrg5hH8QxLFSXnNI.jpg",
  department: "CSM",
  job_title: "CSM",
};

// Company-level scalar fallbacks (the "book a meeting" CTAs + mailto links read
// these off current_company, not off the CSM object).
export const PIOTR_CSM_EMAIL = "piotr.kochanski@teamsunday.com";
export const PIOTR_CSM_BOOKING_CALENDAR =
  "https://calendar.google.com/calendar/appointments/schedules/AcZssZ2sgzlTVi1Gnnzl1gbZ9Pv7DXX4DE1r5QwEXUUbxQ1SGweXSFNmqXVpRKbJbwF63WgA5fHwHbwy?gv=true";
